import * as Contract from '@tableau/hybrid-widgets-contract';
import * as React from 'react';
import * as widgets from '@tableau/widgets';
import { menuItemsToWidgetsMenuItems } from '../utils/MenuUtils';

type MenuButtonWidgetProps = widgets.MenuButtonProps &
  React.ButtonHTMLAttributes<HTMLButtonElement> &
  React.RefAttributes<HTMLButtonElement>;

let nextId: number = Date.now();

function generateId(): string {
  return `tab-hybrid-popup-menu-button-widget-flyout-${nextId++}`;
}

export const HybridPopupMenuButtonWidget: React.FC<Contract.HybridPopupMenuButtonProps> = props => {
  const [isOpen, setOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const [menuId] = React.useState<string>(generateId());

  const widgetProps: MenuButtonWidgetProps = {
    'aria-controls': menuId,
    children: props.children,
    density: props.density,
    disabled: props.disabled,
    isOpen,
    onClick: () => setOpen(!isOpen),
    testId: props.testId,
    title: props.title,
  };

  return (
    <>
      <widgets.MenuButtonWidget {...widgetProps} ref={setAnchorEl} style={props.containerStyle} />
      {isOpen && (
        <widgets.FlyoutListMenuWidget
          anchorEl={anchorEl!}
          toggleEl={anchorEl!}
          allowAutoPosition
          subMenuAllowAutoPosition
          id={menuId}
          testId={props.testId}
          requestCloseAll={() => setOpen(false)}
          maxHeight={props.maxHeight}
          zIndex={props.zIndex}
          menuStyle={{ minWidth: anchorEl!.getBoundingClientRect().width }}
          menuItemInfos={menuItemsToWidgetsMenuItems(props.populateItems())}
          onSelect={value => {
            setOpen(false);
            props.onSelect(value);
          }}
        />
      )}
    </>
  );
};
